import React, { useState, Fragment, useRef } from "react";
import styled from "styled-components";
import { Title2 } from "../../../components/Typography";
import OrderSubmitted from "./OrderSubmitted";
import OrderAccepted from "./OrderAccepted";
import OrderComplete from "./OrderComplete";
import OrderOnDelivery from "./OrderOnDelivery";
import OrderRefunded from "./OrderRefunded";
import OrderTechnicalDifficulty from "./OrderTechnicalDifficulty";
import StaticOrderStatusCard from "./StaticOrderStatusCard";
import {
  ORDER_REFUNDED,
  ORDER_SUBMITTED,
  ORDER_ACCEPTED,
  ORDER_COMPLETE,
  ORDER_ON_DELIVERY,
} from "../orderStatusTypes";
import OrderStatusModal from "./OrderStatusModal";
import moment from "moment";
import { FlatButton } from "../../../components/Buttons";
import FeedbackModal from "./FeedbackModal";
import { Body } from "../../../components/Typography";
import Icon from "./Icon";
import Slider from "react-slick";
import appConfig from "../../../../app-config";
import { DELIVERY, PICKUP } from "../../OrderSetting/orderSettingTypes";

const NextArrow = styled.div`
  @media (max-width: 1100px) {
    right: 10px !important;
  }
  @media (orientation: landscape) and (max-width: 1100px) {
    right: -20px !important;
  }
  @media (max-width: 786px) {
    display: none !important;
  }
`;

const PrevArrow = styled.div`
  @media (max-width: 786px) {
    display: none !important;
  }
`;

function OrderHistoryNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <NextArrow
      className={className}
      style={{
        ...style,
        display: "block",
        background: "#fff",
        borderRadius: "50%",
        border: "none",
        height: "40px",
        width: "40px",
        boxShadow: " 0 2px 5px 0 rgba(59, 76, 112, 0.24)",
        top: props.feedbackRef.current ? "35%" : "45%",
        // right: '-10px',
        opacity: 1,
        fontSize: "16px",
        lineHeight: "40px",
        textAlign: "center",
      }}
      onClick={onClick}
    />
  );
}

function OrderHistoryPrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <PrevArrow
      className={className}
      style={{
        ...style,
        display: "block",
        background: "#fff",
        borderRadius: "50%",
        border: "none",
        height: "40px",
        width: "40px",
        boxShadow: " 0 2px 5px 0 rgba(59, 76, 112, 0.24)",
        top: props.feedbackRef.current ? "35%" : "45%",
        // left: '-20px',
        opacity: 1,
        lineHeight: "40px",
        textAlign: "center",
        zIndex: "1",
      }}
      onClick={onClick}
    />
  );
}

const slideSettings = (feedbackRef) => {
  return {
    dots: false,
    infinite: false,
    speed: 600,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    initialSlide: 0,
    swipeToSlide: true,
    nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
    prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 2,
          nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
          prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 0,
          dots: false,
          infinite: false,
          speed: 600,
          arrows: true,
          nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
          prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 0,
          dots: false,
          infinite: false,
          speed: 600,
          arrows: true,
          nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
          prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
        },
      },
      {
        breakpoint: 786,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          initialSlide: 0,
          dots: false,
          infinite: false,
          speed: 600,
          arrows: true,
          nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
          prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          initialSlide: 0,
          dots: false,
          infinite: false,
          speed: 600,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };
};

const Wrapper = styled.div`
  // display: grid;
  // grid-template-columns: repeat(2, 1fr);
  // grid-gap: 8px;
  // margin-top: 32px;

  // @media (max-width: 786px) {
  //   grid-template-columns: 1fr;
  //   grid-gap: 8px;
  // }
  margin: 32px auto 0 auto;
  max-width: 480px;
`;

const OrderStatusWrapper = styled.div`
  width: 100%;
  padding-bottom: 60%;
  background: ${(props) => props.theme.orderStatusBackgroundColor};
  border-radius: 10px;
  position: relative;
  cursor: ${(props) => !props.isForModal && "pointer"};

  &:hover {
    background: ${(props) =>
      !props.isForModal && props.theme.orderStatusBackgroundColorHover};
    transition: all 0.25s ease;
  }

  @media screen and (device-aspect-ratio: 40/71) {
    min-height: 180px;
  }

  @media (max-width: 280px) {
    min-height: 180px;
  }
`;

const ContentWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 24px;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-gap: 10px;
  background-image: ${(props) =>
    props.theme.orderStatusCardBackgroundImage
      ? `url(${props.theme.orderStatusCardBackgroundImage})`
      : "none"};

  @media (max-width: 479px) {
    padding: 20px;
  }
`;

const Content = styled.div`
  align-self: end;
  margin-top: auto;

  @media (max-width: 479px) {
    display: none;
  }
`;

const ContentMobile = styled.div`
  align-self: end;
  margin-top: auto;

  @media (min-width: 479px) {
    display: none;
  }
`;

const SubContentMobile = styled.div`
  @media (min-width: 480px) {
    display: none;
  }
`;

const Title = styled(Title2)`
  color: ${(props) => props.theme.orderStatusTitleColor};
`;

const FeedbackWrapper = styled.div`
  width: 100%;
  border-radius: 12px;
  padding: 12px 16px;
  background: #f7f7f7;
  display: grid;
  grid-gap: 12px;
  grid-template-columns: auto 1fr 1fr;
  align-items: center;
  margin-top: 15px;

  @media (max-width: 480px) {
    grid-template-columns: auto 1fr;
  }
`;

const Button = styled(FlatButton)`
  border-radius: 17.5px;
  padding: 7px 16px;
  background: ${(props) => props.theme.primaryButtonBackgroundColor};
  color: ${(props) => props.theme.primaryButtonFontColor};

  &:hover {
    background: ${(props) => props.theme.primaryButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const Text = styled(Body)`
  color: ${(props) => props.theme.orderStatusProgressTextColor};

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const SlideWrap = styled.div`
  margin-top: 10px;
  .slick-slide {
    padding: 0 5px;
  }

  .slick-list {
    margin: 0 2em;
  }
  @media (min-width: 1600px) {
    .slick-list {
      width: 1070px !important;
    }
  }
  @media (min-width: 1900px) {
    .slick-list {
      width: 1255px !important;
    }
  }
  @media (orientation: landscape) and (max-width: 1100px) {
    .slick-list {
      width: 1255px !important;
    }
  }
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  @media (max-width: 480px) {
    grid-column: span 2;
  }
`;

const renderIcon = (status, orderType) => {
  switch (status) {
    case ORDER_SUBMITTED:
      return (
        <Icon
          className={
            (appConfig.orderStatusIcons &&
              appConfig.orderStatusIcons.order_submitted) ||
            "fa fa-check-circle"
          }
        />
      );
    case ORDER_ACCEPTED:
      return (
        <Icon
          className={
            (appConfig.orderStatusIcons &&
              appConfig.orderStatusIcons.order_accepted) ||
            "fas fa-hat-chef"
          }
        />
      );
    case ORDER_REFUNDED:
      return (
        <Icon
          className={
            (appConfig.orderStatusIcons &&
              appConfig.orderStatusIcons.order_refunded) ||
            "fas fa-exclamation-triangle"
          }
        />
      );
    case ORDER_COMPLETE:
      return (
        <Icon
          className={
            (appConfig.orderStatusIcons &&
              appConfig.orderStatusIcons.order_complete) ||
            (orderType === PICKUP
              ? "fas fa-store"
              : orderType === DELIVERY
              ? "fas fa-car-side"
              : "fas fa-shopping-bag")
          }
        />
      );
    case ORDER_ON_DELIVERY:
      return (
        <Icon
          className={
            (appConfig.orderStatusIcons &&
              appConfig.orderStatusIcons.order_on_delivery) ||
            "fas fa-car-side"
          }
        />
      );
  }
};

const renderImage = (status) => {
  switch (status) {
    case ORDER_SUBMITTED:
      return <img src={appConfig.orderStatusImages.order_submitted} />;
    case ORDER_ACCEPTED:
      return <img src={appConfig.orderStatusImages.order_accepted} />;
    case ORDER_REFUNDED:
      return <img src={appConfig.orderStatusImages.order_refunded} />;
    case ORDER_COMPLETE:
      return <img src={appConfig.orderStatusImages.order_complete} />;
    case ORDER_ON_DELIVERY:
      return <img src={appConfig.orderStatusImages.order_on_delivery} />;
  }
};

const isOrderWithFirebaseUrl = (orderHistory, orderStatus) => {
  const orderHist = orderHistory.filter(
    (order) => order.order_id == orderStatus.orderId,
  );

  if (orderHist[0]?.firebase_uri && orderHist[0]?.firebase_uri?.length !== 0) {
    return true;
  } else {
    return false;
  }
};

const renderStatus = (status, orderStatus, orderHistory, orderType) => {
  const orderHist = orderHistory.filter(
    (order) => order.order_id == orderStatus.orderId,
  );
  if (!orderHist[0]?.firebase_uri || orderHist[0]?.firebase_uri?.length === 0) {
    return <OrderTechnicalDifficulty />;
  } else if (appConfig.isStaticOrderStatusCard) {
    return <StaticOrderStatusCard orderStatus={orderStatus} />;
  } else {
    switch (status) {
      case ORDER_SUBMITTED:
        if (appConfig.appSource === "madradish") {
          return <OrderComplete orderStatus={orderStatus} />;
        }
        return <OrderSubmitted />;
      case ORDER_ACCEPTED:
        if (appConfig.appSource === "madradish") {
          return (
            <OrderComplete orderStatus={orderStatus} orderType={orderType} />
          );
        }
        return (
          <OrderAccepted orderStatus={orderStatus} orderType={orderType} />
        );
      case ORDER_REFUNDED:
        return (
          <OrderRefunded orderStatus={orderStatus} orderType={orderType} />
        );
      case ORDER_COMPLETE:
        return (
          <OrderComplete orderStatus={orderStatus} orderType={orderType} />
        );
      case ORDER_ON_DELIVERY:
        return (
          <OrderOnDelivery orderStatus={orderStatus} orderType={orderType} />
        );
    }
  }
};

const SliderWrapper = ({ isMultiple, feedbackRef, children }) => {
  if (!isMultiple) {
    return <Wrapper>{children}</Wrapper>;
  }
  return (
    <SlideWrap>
      <Slider {...slideSettings(feedbackRef)}>{children}</Slider>
    </SlideWrap>
  );
};

const OrderStatus = ({
  orderStatusList,
  sendReview,
  feedbackModalIsVisible,
  openFeedbackModal,
  closeFeedbackModal,
  currency,
  is_tip_enabled,
  orderHistory,
}) => {
  const os = [orderStatusList[0]];
  const [orderStatusModalData, setOrderStatusModalData] = useState(null);
  const [feedbackModalData, setFeedbackModalData] = useState(null);
  const feedbackRef = useRef();
  const isMultiple = orderStatusList.length > 1;

  return (
    <Fragment>
      <SliderWrapper isMultiple={isMultiple} feedbackRef={feedbackRef}>
        {orderStatusList.map((orderStatus, index) => {
          const status = orderStatus.status;
          const orderType = orderStatus.order_type;

          return (
            <div
              key={index}
              // style={{ margin: '0 10px'}}
            >
              <OrderStatusWrapper
                onClick={() => {
                  isOrderWithFirebaseUrl(orderHistory, orderStatus) &&
                    setOrderStatusModalData(orderStatus);
                }}
                isForModal={
                  isOrderWithFirebaseUrl(orderHistory, orderStatus)
                    ? false
                    : true
                }
                key={index}
              >
                <ContentWrapper>
                  <div>
                    <Title id="OrderStatus-Title">Order Status</Title>
                    {isMultiple && (
                      <div style={{ marginTop: "4px" }}>
                        <Text id="OrderStatus-PlacedOn">Placed on:</Text>
                        <Text id="OrderStatus-CreatedAt">
                          {moment(
                            orderStatus.order_created_at,
                            "YYYY-MM-DD HH:mm:ss",
                          ).format("MMM DD, hh:mm A")}
                        </Text>
                      </div>
                    )}
                  </div>
                  <Content>
                    {renderStatus(status, orderStatus, orderHistory)}
                  </Content>
                  <ContentMobile>
                    <SubContentMobile>
                      {appConfig.isOrderStatusIcon && (
                        <div style={{ alignSelf: "center" }}>
                          {appConfig.orderStatusImages
                            ? renderImage(status)
                            : renderIcon(status, orderType)}
                        </div>
                      )}
                    </SubContentMobile>
                    {renderStatus(status, orderStatus, orderHistory)}
                  </ContentMobile>
                </ContentWrapper>
              </OrderStatusWrapper>
              {appConfig.appSource !== "madradish" &&
              (status === ORDER_COMPLETE || status === ORDER_ON_DELIVERY) ? (
                <FeedbackWrapper ref={feedbackRef}>
                  <div>
                    <i className="fal fa-user-headset"></i>
                  </div>

                  <div>
                    Tell us how we did today. Your feedback helps us improve.
                  </div>

                  <ButtonWrapper>
                    <Button
                      id="OrderStatus-FeedbackButton"
                      onClick={() => {
                        setFeedbackModalData(orderStatus);
                        openFeedbackModal();
                      }}
                    >
                      Rate your order
                    </Button>
                  </ButtonWrapper>
                </FeedbackWrapper>
              ) : null}
            </div>
          );
        })}
      </SliderWrapper>
      <FeedbackModal
        feedbackModalData={feedbackModalData}
        setFeedbackModalData={setFeedbackModalData}
        sendReview={sendReview}
        feedbackModalIsVisible={feedbackModalIsVisible}
        openFeedbackModal={openFeedbackModal}
        closeFeedbackModal={closeFeedbackModal}
      />

      <OrderStatusModal
        orderStatusModalData={orderStatusModalData}
        setOrderStatusModalData={setOrderStatusModalData}
        isMultiple={isMultiple}
        currency={currency}
        is_tip_enabled={is_tip_enabled}
      />
    </Fragment>
  );
};

export default OrderStatus;
